import { h, } from "preact";

import {
    Divider,
    Stack,
    Typography,
} from "@mui/material";

import FormField from "../Common/FormField";
import FormSelect from "../Common/FormSelect";
import FormToggle from "../Common/FormToggle";
import FormMultiToggle from "../Common/FormMultiToggle";
import Ges from "../GES/";
import Dpe from "../DPE/";
import FormDate from "../Common/FormDate";
export default function Attic({ upperState, upperHandleChange }) {

    const handleChange = (event) => {

        upperHandleChange(event);
    };

    return (
        <Stack spacing={1}>

            <Stack>
                <FormField upperState={upperState} id="co_property_lots" placeholder="No" handleChange={handleChange} num={true} disabled={upperState.mandate_signed} helper={<Stack><Typography>Indiquer le numéro de lot de copropriété du parking.</Typography></Stack>} />
                <FormMultiToggle upperState={upperState} options={[{ o: "49", l: "Avant 1949" }, { o: "97", l: "Entre les deux" }, , { o: "00", l: "Après 1996" }, { o: "?", l: "Ne sais pas" }]} id="construction_year" handleChange={handleChange} exclusive={true} helper={<Stack><Typography>Indiquer la période de construction de l'immeuble.</Typography></Stack>} />
                <Divider />
                <FormField upperState={upperState} id="surface" placeholder="Surface habitable en m2" handleChange={handleChange} num={true} helper={<Stack><Typography>Indiquer la surface habitable du logement</Typography><Typography>dite "surface loi Carrez".</Typography></Stack>} />
                <Divider />
                <FormField upperState={upperState} id="floors" placeholder="Etage" handleChange={handleChange} helper={<Stack><Typography>Indiquer le nombre d'étages de l'immeuble.</Typography></Stack>} />
                {upperState.floors !== "" && <FormSelect upperState={upperState} id="floor" handleChange={handleChange} max={upperState.floors} helper={<Stack><Typography>Indiquer l'étage de l'appartement.</Typography></Stack>} />}

                <Divider />
                <FormToggle upperState={upperState} id="dpe_and_ges_available" handleChange={handleChange} helper={<Stack><Typography>Diagnostic de Performance Energétique.</Typography></Stack>} />
                {upperState.dpe_and_ges_available == "O" && (<FormField upperState={upperState} id="dpe" placeholder="DPE" handleChange={handleChange} num={true} helper={<Stack spacing={1}><Typography variant="body1">Reportez la valeur numérique indiquée dans le</Typography><Typography>Diagnostic de Performance Energétique.</Typography><Typography variant="h5">Etiquette énergie</Typography><Dpe nb={upperState.dpe} /></Stack>} />)}
                {upperState.dpe_and_ges_available == "O" && (<FormField upperState={upperState} id="ges" placeholder="GES" handleChange={handleChange} num={true} helper={<Stack spacing={1}><Typography variant="body1">Reportez la valeur numérique indiquée dans le</Typography><Typography>Diagnostic de Performance Energétique.</Typography><Typography variant="h5">Etiquette climat</Typography><Ges nb={upperState.ges} /></Stack>} />)}
                <Divider />
                <FormToggle upperState={upperState} id="is_not_free" handleChange={handleChange} helper={<Stack><Typography>Indiquez si le bien fait l'objet d'un contrat de location.</Typography></Stack>} />
                {upperState.is_not_free == "O" && (<FormField upperState={upperState} id="rent" placeholder="€/an" handleChange={handleChange} num={true} helper={<Stack spacing={1}>Indiquer le montant du loyer annuel hors charges.</Stack>} />)}
                {upperState.is_not_free == "O" && (<FormDate upperState={upperState} id="rent_term" handleChange={handleChange} num={true} helper={<Stack spacing={1}>Indiquer la date de fin du contrat de location (bail).</Stack>} />)}
            </Stack>


        </Stack>
    );
}
